/**
 * Format a date to a relative time string (e.g., "2 часа назад")
 */
export function formatRelativeTime(date: string | Date): string {
  const now = new Date();
  const then = typeof date === 'string' ? new Date(date) : date;
  const diffMs = now.getTime() - then.getTime();
  const diffSec = Math.floor(diffMs / 1000);
  const diffMin = Math.floor(diffSec / 60);
  const diffHour = Math.floor(diffMin / 60);
  const diffDay = Math.floor(diffHour / 24);
  const diffWeek = Math.floor(diffDay / 7);
  const diffMonth = Math.floor(diffDay / 30);

  if (diffSec < 60) {
    return 'только что';
  }

  if (diffMin < 60) {
    return pluralize(diffMin, 'минуту', 'минуты', 'минут') + ' назад';
  }

  if (diffHour < 24) {
    return pluralize(diffHour, 'час', 'часа', 'часов') + ' назад';
  }

  if (diffDay < 7) {
    return pluralize(diffDay, 'день', 'дня', 'дней') + ' назад';
  }

  if (diffWeek < 4) {
    return pluralize(diffWeek, 'неделю', 'недели', 'недель') + ' назад';
  }

  if (diffMonth < 12) {
    return pluralize(diffMonth, 'месяц', 'месяца', 'месяцев') + ' назад';
  }

  // Fallback to date string for older dates
  return then.toLocaleDateString('ru-RU', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  });
}

/**
 * Russian pluralization helper
 */
function pluralize(n: number, one: string, few: string, many: string): string {
  const mod10 = n % 10;
  const mod100 = n % 100;

  if (mod100 >= 11 && mod100 <= 19) {
    return `${n} ${many}`;
  }

  if (mod10 === 1) {
    return `${n} ${one}`;
  }

  if (mod10 >= 2 && mod10 <= 4) {
    return `${n} ${few}`;
  }

  return `${n} ${many}`;
}
